export default {
  actionTypes: {
    sendResetPasswordRequest: 'RESET_PASSWORD_SEND_REQUEST',
    validateResetPasswordToken: 'RESET_PASSWORD_VALIDATE_TOKEN',
    resetPassword: 'RESET_PASSWORD_RESET',
  },
  mutationTypes: {
    setResetPasswordRequestLoading: 'RESET_PASSWORD_SET_SEND_REQUEST_LOADING',
    setResetTokenValidating: 'RESET_PASSWORD_SET_TOKEN_VALIDATING',
    setResetPasswordLoading: 'RESET_PASSWORD_SET_REQUEST_LOIADING',
  },
};
